// removed by extract-text-webpack-plugin
module.exports = {"vpMediaList":"vpMediaList___plyCi","vpMediaContainer":"vpMediaContainer___-AEPG","vpActiveMediaView":"vpActiveMediaView___21Xb_","vpMediaViewItem":"vpMediaViewItem___2hEQs"};


//////////////////
// WEBPACK FOOTER
// ./src/vp-ui/components/VpMediaViewList/VpMediaViewList.module.less
// module id = 1407
// module chunks = 29